import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ArticleProduct from './ArticleProduct';
import SubHead from '../SubHead/SubHead';
import BodyText from '../BodyText/BodyText';
import './tagged-shoppable.scss';
import { scrollToTopOf, isValid, isText, decodeTags } from '../../../../utils';
import { APP_ENV } from '../../../../consts';


class TaggedShoppable extends Component { 
	constructor(props) {
    super(props);
    this.state = {
        maxRows: 1
    }
    this.handleClick = this.handleClick.bind(this);
    this.direction = "More";
    this.taggedShoppableRef = React.createRef();
    }

    handleClick() {
        let { maxRows } = this.state;
        (this.direction === "More") ? maxRows += 1 : maxRows -= 1;
        this.setState({ maxRows });
        if (this.direction === "Less") {
            setTimeout(() => {
                scrollToTopOf(this.taggedShoppableRef.current, 80);
              }, 50)
        } else return;
    }

	render() {
		const { maxRows } = this.state;
		const { data, isMobile, className, isClient, category } = this.props;
        if (!isValid(data)) { return null; }
		const { header=null, hedBody=null, products=[], title=null } = data;
        let currentRow = 0;
        let doMap = true;
        let productsArr = [];
        const size = isMobile ? 2 : 3;
        if (products.length <= size) {
            productsArr.push(products);
        } else {
            for(var i = 0; i < products.length; i += size) {
                productsArr.push(products.slice(i, i+size));
            }
        }
        
    const renderedProducts = productsArr.map((arrArticles, i) => {
    	if (!doMap || !isValid(arrArticles)) {
    		return;
    	}
        const colorClass = (i%2 === 0) ? "blue" : "pink";

    	const productRow = arrArticles.map((product, i) => {
            if (!isValid(product)) {
                return;
            }
    		const { name, dek, buttonUrl, buttonText, productImage, sponsored, oldPrice, price, productTitle, productTeaser, productDescription, } = product;
    		const productData = {
    			name,
    			dek,
    			buttonURL: buttonUrl,
                buttonTxt: buttonText,
    			imageSrc: productImage,
    			sponsored,
                oldPrice,
                price,
                productTitle, 
                productTeaser,
                productDescription,
    		};
    		return (
    			<ArticleProduct
		        key={i}
		        product={productData}
		        onLoad={()=>{}}
		        isCarousel={false}
		        isMobile={isMobile} />
    		);
    	});

        if (maxRows === 1) {
            this.direction = "More";
        }
        
    	if (currentRow < maxRows) {
            currentRow++;
            let isEnd = false;
            const className = `tagged-products ${colorClass}`;
            if (currentRow === maxRows) {
                if (maxRows === productsArr.length) {
                    isEnd = true;
                    this.direction = "Less";
                }
            }
    		return (
                <Fragment>
                <div className={className}>
                    {productRow}
                </div>  
                {isEnd && (productsArr.length !== 1) &&
                    <div className="tagged-products end">
                        <a className='button' onClick={this.handleClick}>Less Products</a>
                    </div>
                }
                </Fragment>

	    	);
    	} else {
    		doMap = false;
            let buttonLabel = `${this.direction} Products`;
    		return (
    			<div className="tagged-products end">   
    			     <a className='button' onClick={this.handleClick}>{buttonLabel}</a>
    			</div>
    		);
    	}
    });
	return (
    	<div className="tagged-shoppable" ref={this.taggedShoppableRef}>
          {header && 
            <div className="shoppable-hed">
                <SubHead data={header} />
            </div>
           }
          {hedBody && <BodyText className="body-text module-subhed" data={hedBody} />}
          {renderedProducts}
        </div>
	);
}

};

TaggedShoppable.propTypes = {
  data: PropTypes.object,
  className: PropTypes.string,
};

export default TaggedShoppable;
